import { render } from "./FileExplorer.vue?vue&type=template&id=0b501408"
import script from "./FileExplorer.vue?vue&type=script&lang=ts"
export * from "./FileExplorer.vue?vue&type=script&lang=ts"

import "./FileExplorer.vue?vue&type=style&index=0&id=0b501408&lang=scss"
script.render = render

export default script